import { render } from "./showRekananMampu.vue?vue&type=template&id=06287cb6"
import script from "./showRekananMampu.vue?vue&type=script&lang=js"
export * from "./showRekananMampu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__